/**
 * Created by Daniel on 12/06/2020.
 * ------ maintenance history ------
 */
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as lodash from 'lodash';
import { select, Store } from '@ngrx/store';
import { of, Subscription } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import * as _lodash from 'lodash';

import { BriefObject } from '../../../tamalelibs/models/brief-object';
import { DateHelperWebService } from '../../../tamalelibs/services/date-helper.web.service';
import { DefinitionSetting, Frequency, PrimaryEntityDrpItem, SchedulerWeeklyOnSelectMode, TimeZone, WorkflowTriggerSource } from '../../../tamalelibs/models/workflow-config.model';
import { SlideSheetActionTypes } from '../../../components/slide-sheet/slide-sheet.model';
import { SlideSheetService } from '../../../services/slide-sheet.service';
import { WorkflowTriggerSettings } from '../../../tamalelibs/models/workflow-config.model';
import { SingleSelectDropdownFilterConfig } from '../../../widgets/single-select-dropdown-filter/single-select-dropdown-filter.model';
import { relationshipTypeSelector } from '../../../redux/reducers/relationship-type.reducer';
import { WorkflowConfigService } from '../../../tamalelibs/services/workflow-config.service';
import { NotificationStyles } from '../../../widgets/notification/notification.model';
import { ToastService } from '../../../widgets/toast/toast.service';
import { fullEntityTypeSelector } from '../../../redux/reducers/entity-type.reducer';
import { AlertWindowService } from '../../../widgets/alert-window/alert-window.service';
import { SingleEntityDropdownFilterConfig } from '../../../widgets/single-entity-dropdown-filter/single-entity-dropdown-filter.model';
import { EntityService } from '../../../tamalelibs/services/entity.service';
import { WorkflowTriggerSettingsConfig, WorkflowTriggerSettingsEventTypes } from './workflow-trigger-settings.model';
import { currentWorkflowFieldsSelector } from '../../../tamalelibs/redux/reducers/workflow.reducer';
import { AlertBtnTypes } from '../../../widgets/alert-window/alert-window.model';
import { WorkflowTriggerSettingsLiterals } from './workflow-trigger-settings.model';
import { WorkflowService } from '../../../tamalelibs/services/workflow.service';

export const ENTITY_DEFAULT_VALUE = 'Select an entity';
export const ENTITY_TYPE_DEFAULT_VALUE = 'Select an entity type';
export const RELATIONSHIP_TYPE_DEFAULT_VALUE = 'Select a relationship';

@Component({
    selector: 'tam-workflow-trigger-settings',
    templateUrl: './workflow-trigger-settings.component.html',
    styleUrls: ['./workflow-trigger-settings.component.scss']
})
export class WorkflowTriggerSettingsComponent implements OnInit, OnDestroy {

    @Input() config: WorkflowTriggerSettingsConfig;
    @ViewChild('primary_entity', { static: false }) primaryEntityEle: any;
    definitionSetting: DefinitionSetting = new DefinitionSetting();
    entity = ENTITY_DEFAULT_VALUE;
    entityConfig: SingleEntityDropdownFilterConfig = new SingleEntityDropdownFilterConfig(true);
    entityItems: Array<PrimaryEntityDrpItem> = [];
    entityItemsAll: Array<PrimaryEntityDrpItem> = [];
    entityType = ENTITY_TYPE_DEFAULT_VALUE;
    entityTypeConfig: SingleSelectDropdownFilterConfig = new SingleSelectDropdownFilterConfig(true);
    noteDepositEntityTypeConfig: SingleSelectDropdownFilterConfig = new SingleSelectDropdownFilterConfig(true);
    everyList: Array<BriefObject>;
    formErrorMsg = {
        projectNameRequired: false,
        triggerMethodRequired: false,
        entityTypeRequired: false,
        relationshipRequired: false,
        noteTriggerRequired: false
    };
    frequencyList: Array<BriefObject> = [
        {
            id: Frequency.MONTHLY,
            value: 'Monthly',
        },
        {
            id: Frequency.WEEKLY,
            value: 'Weekly',
        },
        {
            id: Frequency.DAILY,
            value: 'Daily',
        }
    ];
    frequencyUnit: string;
    isEntityTypeChecked: boolean;
    isRelationshipChecked: boolean;
    isScheduledJobTrigger = false;
    isNoteDepositTrigger = false;
    minTime: Date;
    maxTime: Date;
    noteTriggerSource: WorkflowTriggerSource;
    onMonthlyList1: Array<BriefObject> = [
        {
            id: 'day',
            value: 'Day',
        },
        {
            id: 'day:L',
            value: 'Last Day',
        },
        {
            id: '1',
            value: 'First',
        },
        {
            id: '2',
            value: 'Second',
        },
        {
            id: '3',
            value: 'Third',
        },
        {
            id: '4',
            value: 'Fourth',
        },
        {
            id: 'L',
            value: 'Last',
        },
    ];
    onMonthlyList2: Array<BriefObject>;
    onWeeklyMode: string = SchedulerWeeklyOnSelectMode.MULTIPLE;
    onWeeklyList: Array<any> = [
        {
            id: 'SUN',
            value: 'Sun',
            selected: false,
        },
        {
            id: 'MON',
            value: 'Mon',
            selected: false,
        },
        {
            id: 'TUE',
            value: 'Tue',
            selected: false,
        },
        {
            id: 'WED',
            value: 'Wed',
            selected: false,
        },
        {
            id: 'THU',
            value: 'Thu',
            selected: false,
        },
        {
            id: 'FRI',
            value: 'Fri',
            selected: false,
        },
        {
            id: 'SAT',
            value: 'Sat',
            selected: false,
        },
    ];
    projectTriggerCons = WorkflowTriggerSettingsLiterals;
    relationshipType = RELATIONSHIP_TYPE_DEFAULT_VALUE;
    relationshipTypeConfig: SingleSelectDropdownFilterConfig = new SingleSelectDropdownFilterConfig(true);
    selectedEntityFieldId: string;
    selectedEvery: BriefObject;
    selectedFrequency: BriefObject;
    selectedOnMonthly1: BriefObject;
    selectedOnMonthly2: BriefObject;
    selectedTimezone: TimeZone;
    startDate: Date;
    time: Date;
    timesteps: any = { hour: 1, minute: 30, second: 60 };
    timezoneList: Array<TimeZone>;
    workflowTriggerSettings: WorkflowTriggerSettings;

    private _destroySubscriptions: Array<Subscription> = [];
    private _monthlyEvery: Array<BriefObject> = [
        {
            id: 1,
            value: '1',
        },
        {
            id: 2,
            value: '2',
        },
        {
            id: 3,
            value: '3',
        },
        {
            id: 6,
            value: '6',
        }
    ];
    private _onMonthlyDayList: Array<BriefObject> = [
        {
            id: '1',
            value: '1',
        },
        {
            id: '2',
            value: '2',
        },
        {
            id: '3',
            value: '3',
        },
        {
            id: '4',
            value: '4',
        },
        {
            id: '5',
            value: '5',
        },
        {
            id: '6',
            value: '6',
        },
        {
            id: '7',
            value: '7',
        },
        {
            id: '8',
            value: '8',
        },
        {
            id: '9',
            value: '9',
        },
        {
            id: '10',
            value: '10',
        },
        {
            id: '11',
            value: '11',
        },
        {
            id: '12',
            value: '12',
        },
        {
            id: '13',
            value: '13',
        },
        {
            id: '14',
            value: '14',
        },
        {
            id: '15',
            value: '15',
        },
        {
            id: '16',
            value: '16',
        },
        {
            id: '17',
            value: '17',
        },
        {
            id: '18',
            value: '18',
        },
        {
            id: '19',
            value: '19',
        },
        {
            id: '20',
            value: '20',
        },
        {
            id: '21',
            value: '21',
        },
        {
            id: '22',
            value: '22',
        },
        {
            id: '23',
            value: '23',
        },
        {
            id: '24',
            value: '24',
        },
        {
            id: '25',
            value: '25',
        },
        {
            id: '26',
            value: '26',
        },
        {
            id: '27',
            value: '27',
        },
        {
            id: '28',
            value: '28',
        },
        {
            id: '29',
            value: '29',
        },
        {
            id: '30',
            value: '30',
        },
        {
            id: '31',
            value: '31',
        }
    ];

    private _onMonthlyXList: Array<BriefObject> = [
        {
            id: '1',
            value: 'Sunday',
        },
        {
            id: '2',
            value: 'Monday',
        },
        {
            id: '3',
            value: 'Tuesday',
        },
        {
            id: '4',
            value: 'Wednesday',
        },
        {
            id: '5',
            value: 'Thursday',
        },
        {
            id: '6',
            value: 'Friday',
        },
        {
            id: '7',
            value: 'Saturday',
        },
    ];
    private _weeklyEvery: Array<BriefObject> = [
        {
            id: 1,
            value: '1',
        },
        {
            id: 2,
            value: '2',
        },
        {
            id: 3,
            value: '3',
        },
        {
            id: 4,
            value: '4',
        }
    ];
    private _workflowTriggerSettingsLoadingOrginial: WorkflowTriggerSettings;

    constructor(
        private _alertWindow: AlertWindowService,
        private _entityService: EntityService,
        private _slideSheetService: SlideSheetService,
        private _store: Store<any>,
        private _toast: ToastService,
        private _workflowService: WorkflowService,
        private _workflowConfigService: WorkflowConfigService) { }

    ngOnInit() {
        // init timezone list
        this._initTimezoneList();
        // int workflowTriggerSetting (new/edit)
        this._initWorkflowTriggerSetting();
        // int projectName and primaryEntity
        this._initDefinitionSetting();
        // init control data
        this._initData();
        // set _workflowTriggerSettingsLoadingOrginial
        this._workflowTriggerSettingsLoadingOrginial = lodash.cloneDeep(this.workflowTriggerSettings);
        // set show/hide scheduled job trigger section
        this.isScheduledJobTrigger = this.workflowTriggerSettings.triggerMethod.scheduleJob;
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }

    filterAdhocEntityValue(event): void {
        this.entityItems = this.entityItemsAll;
        this.entityItems = this.entityItems.filter(item => item.fieldDefEntityName.toLowerCase().indexOf(event.toLowerCase()) > -1);
    }

    onBtnClose() {
        const parameterChanged = lodash.isEqual(this.workflowTriggerSettings, this._workflowTriggerSettingsLoadingOrginial);
        if (parameterChanged) {
            // close slide sheet
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.CLOSE,
                payload: ''
            });
        } else {
            const subscription = this._alertWindow.warn(
                'You have unsaved changes',
                ['Are you sure you want to discard the changes?'],
                'Discard',
                'Go Back',
                'slideSheet',
                true).subscribe((result: boolean) => {
                    if (result) {
                        // change to default value
                        // this._workflowConfigService.setWorkflowTriggerSettingConfig('');
                        // this.workflowTriggerSettings.multipleEntity.entityType = ENTITY_TYPE_DEFAULT_VALUE;
                        // this.workflowTriggerSettings.multipleEntity.relationship.type = RELATIONSHIP_TYPE_DEFAULT_VALUE;
                        // this.workflowTriggerSettings.multipleEntity.relationship.parentEntity = ENTITY_DEFAULT_VALUE;
                        // close slide sheet
                        this._slideSheetService.slideSheetActionSubject$.next({
                            type: SlideSheetActionTypes.CLOSE,
                            payload: ''
                        });
                    }
                    subscription.unsubscribe();
                });
        }
    }

    onBtnSave() {
        // valid the fields
        this._changeTriggerMethodErrorMsgStatus();
        this._changeEntityTypeErrorMsgStatus();
        this._changeRelationshipErrorMsgStatus();
        this._changeProjectNameErrorMsgStatus();
        this._validateNoteTrigger();
        // save workflow trigger settings
        if (!this.formErrorMsg.relationshipRequired &&
            !this.formErrorMsg.entityTypeRequired &&
            !this.formErrorMsg.triggerMethodRequired &&
            !this.formErrorMsg.projectNameRequired &&
            !this.formErrorMsg.noteTriggerRequired) {
            this._saveSetting(false);
        } else {
            const subscription = this._alertWindow.warn('You have incomplete settings',
                ['Do you want to save settings or complete the settings?'],
                'OK, I want to complete', 'Save', 'slideSheet', '', AlertBtnTypes.primary).subscribe((result: boolean) => {
                    if (!result) {
                        this._saveSetting(true);
                    }
                    subscription.unsubscribe();
                });
        }
    }

    onChangeEvery(value: BriefObject) {
        this.selectedEvery = value;
        this.workflowTriggerSettings.triggerScheduler.every = this.selectedEvery.id;
        if (this.selectedFrequency.id === Frequency.WEEKLY) {
            if (this.selectedEvery.id > 1) {
                const tempList = this.onWeeklyList.filter(item => item.selected);
                if (!tempList || tempList.length === 0 || tempList.length > 1) {
                    this._setDefaultWeeklyOn();
                }
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.SINGLE;
            } else {
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.MULTIPLE;
                const tempList = this.onWeeklyList.filter(item => item.selected);
                if (!tempList || tempList.length === 0) {
                    this._setDefaultWeeklyOn();
                }
            }
        }
    }

    onChangeFrequency(value: BriefObject) {
        this.selectedFrequency = value;
        this._afterChangeFrequency();
    }

    onChangeOnMonthly1(value: BriefObject) {
        this.selectedOnMonthly1 = value;
        if (this.selectedOnMonthly1.id === 'day') {
            this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyDayList);
            this.onChangeOnMonthly2(this.onMonthlyList2[0]);
        } else if (this.selectedOnMonthly1.id === 'day:L') {
            this.onMonthlyList2 = [];
            this.selectedOnMonthly2 = null;
            this.workflowTriggerSettings.triggerScheduler.on = this.selectedOnMonthly1.id;
        } else {
            this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyXList);
            this.onChangeOnMonthly2(this.onMonthlyList2[1]);
        }
    }

    onChangeOnMonthly2(value: BriefObject) {
        this.selectedOnMonthly2 = value;
        this.workflowTriggerSettings.triggerScheduler.on = this.selectedOnMonthly1.id + ':' + this.selectedOnMonthly2.id;
    }

    onChangeOnWeekly(value: boolean, index: number) {
        this.onWeeklyList[index].selected = !this.onWeeklyList[index].selected;
        let tempList = this.onWeeklyList.filter(item => item.selected);
        if (!tempList || tempList.length === 0) {
            if (this.selectedEvery.id === 1) {
                this.onWeeklyList[index].selected = !this.onWeeklyList[index].selected;
                this.onWeeklyList = lodash.cloneDeep(this.onWeeklyList); // kendo button group does not support select at least one when mode is multiple, so need to clone deep to triger refresh kendo button group data source to make sure select at least one
            } else {
                return; // Kendo button group behavior: when mode is single, one click will trigger this function twice
            }
        }
        tempList = this.onWeeklyList.filter(item => item.selected);
        this.workflowTriggerSettings.triggerScheduler.on = tempList.map(item => item.id).join(',');
    }

    onChangeStartDate(value: Date, isFromUser: boolean = true) {
        if (isFromUser) {
            const tempYear = value.getFullYear();
            const tempMonth = value.getMonth();
            const tempDayOfMonth = value.getDate();
            this.startDate = new Date(tempYear, tempMonth, tempDayOfMonth);
        }
        // this.workflowTriggerSettings.triggerScheduler.startDate = this._workflowConfigService.parseStartDateFromUIToServer(this.startDate, this.workflowTriggerSettings.minuteOffset);
        this.workflowTriggerSettings.triggerScheduler.startDate = this.startDate;
    }

    onChangeTime(value: Date) {
        const hourNum = value.getHours();
        const minuteNum = value.getMinutes();
        let minuteStr = '';
        if (minuteNum === 0) {
            minuteStr = '00';
        } else {
            minuteStr = minuteNum.toString();
        }
        this.workflowTriggerSettings.triggerScheduler.time = hourNum.toString() + ':' + minuteStr;
        this._initTime();
    }

    onChangeTimezone(value: TimeZone) {
        this.selectedTimezone = value;
        this.workflowTriggerSettings.triggerScheduler.timezone = this.selectedTimezone.id;
        this.workflowTriggerSettings.minuteOffset = this.selectedTimezone.offset;
        // keep start date what it is.
        // this.workflowTriggerSettings.triggerScheduler.startDate = this._workflowConfigService.parseStartDateFromUIToServer(this.startDate, this.workflowTriggerSettings.minuteOffset);
    }

    onCheckedChange() {
        this.isScheduledJobTrigger = this.workflowTriggerSettings.triggerMethod.scheduleJob;
        this.isNoteDepositTrigger = this.workflowTriggerSettings.triggerMethod.noteDeposit;
        if (this.isNoteDepositTrigger) {
            if (!this.workflowTriggerSettings.triggerSource.includes(this.noteTriggerSource)) {
                this.workflowTriggerSettings.triggerSource.push(this.noteTriggerSource);
            }
        } else {
            this.workflowTriggerSettings.triggerSource = [];
        }
        this._changeTriggerMethodErrorMsgStatus();
    }

    onEntityTypeCheckedChange() {
        this.workflowTriggerSettings.multipleEntity.isEntityTypeOptionChecked = !this.workflowTriggerSettings.multipleEntity.isEntityTypeOptionChecked;
        this._changeEntityTypeErrorMsgStatus();
    }

    onProjectNameBlur() {
        this._changeProjectNameErrorMsgStatus();
    }

    onRelationshipCheckedChange() {
        this.workflowTriggerSettings.multipleEntity.isRelationshipOptionChecked = !this.workflowTriggerSettings.multipleEntity.isRelationshipOptionChecked;
        this._changeRelationshipErrorMsgStatus();
    }

    onSelectEntityClick(event) {
        this.entityConfig.open$.next(event.target);
    }

    onSelectEntityTypeClick(event) {
        this.entityTypeConfig.open$.next(event.target);
    }

    onSelectRelationshipTypeClick(event) {
        this.relationshipTypeConfig.open$.next(event.target);
    }

    onPrimaryyEntityDropdownFocus(e: any) {
        this._togglePrimaryEntity();
    }

    private _afterChangeFrequency() {
        this.workflowTriggerSettings.triggerScheduler.frequency = this.selectedFrequency.id;
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            this.everyList = this._monthlyEvery;
            this.onChangeEvery(this.everyList[0]);
            this.onChangeOnMonthly1(this.onMonthlyList1[2]);
            this.frequencyUnit = 'month(s)';
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.everyList = this._weeklyEvery;
            this.onChangeEvery(this.everyList[0]);
            this._setDefaultWeeklyOn();
            this.frequencyUnit = 'week(s)';
        } else {
            this.everyList = [];
            this.selectedEvery = null;
            this.workflowTriggerSettings.triggerScheduler.every = 1;
            this.frequencyUnit = null;
            delete this.workflowTriggerSettings.triggerScheduler.on;
        }
    }

    private _changeEntityTypeErrorMsgStatus() {
        if (this.isEntityTypeChecked) {
            if (this.entityType === ENTITY_TYPE_DEFAULT_VALUE) {
                this.formErrorMsg.entityTypeRequired = true;
            } else {
                this.formErrorMsg.entityTypeRequired = false;
            }
        } else {
            this.formErrorMsg.entityTypeRequired = false;
        }
    }

    private _changeProjectNameErrorMsgStatus() {
        if (this.definitionSetting && this.definitionSetting.projectName && this.definitionSetting.projectName.name) {
            this.formErrorMsg.projectNameRequired = false;
        } else {
            this.formErrorMsg.projectNameRequired = true;
        }
    }

    private _changeRelationshipErrorMsgStatus() {
        if (this.isRelationshipChecked) {
            if (this.relationshipType === RELATIONSHIP_TYPE_DEFAULT_VALUE || this.entity === ENTITY_DEFAULT_VALUE) {
                this.formErrorMsg.relationshipRequired = true;
            } else {
                this.formErrorMsg.relationshipRequired = false;
            }
        } else {
            this.formErrorMsg.relationshipRequired = false;
        }
    }

    private _changeTriggerMethodErrorMsgStatus() {
        const isManual = this.workflowTriggerSettings.triggerMethod.manual;
        const isScheduleJob = this.workflowTriggerSettings.triggerMethod.scheduleJob;
        const isEmailDeposit = this.workflowTriggerSettings.triggerMethod.emailDeposit;
        const isNoteDeposit = this.workflowTriggerSettings.triggerMethod.noteDeposit;
        const isEntityDeposit = this.workflowTriggerSettings.triggerMethod.entityDeposit;

        if (isManual || isScheduleJob || isEmailDeposit || isNoteDeposit || isEntityDeposit) {
            this.formErrorMsg.triggerMethodRequired = false;
        } else {
            this.formErrorMsg.triggerMethodRequired = true;
        }
        if (!isNoteDeposit) {
            this.formErrorMsg.noteTriggerRequired = false;
        }
    }

    private _handleLogicAfterSave(response) {
        if (response) {
            this._toast.notify({
                message: 'Workflow Settings applied successfully.',
                style: NotificationStyles.Success
            });
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.CLOSE,
                payload: ''
            });
        } else {
            this._toast.notify({
                message: 'Workflow Settings applied failed.',
                style: NotificationStyles.Error
            });
        }
    }

    private _validateNoteTrigger() {
        if (this.workflowTriggerSettings.triggerMethod.noteDeposit) {
            this.formErrorMsg.noteTriggerRequired = !this.noteTriggerSource || !this.noteTriggerSource.objectTypeID;
        }
    }

    private _handleSpecialData() {
        // clear the data if the checkbox is unchecked
        if (!this.isEntityTypeChecked) {
            this.workflowTriggerSettings.multipleEntity.entityType = '';
        }
        if (!this.isRelationshipChecked) {
            this.workflowTriggerSettings.multipleEntity.relationship.parentEntity = '';
            this.workflowTriggerSettings.multipleEntity.relationship.type = '';
        }
    }

    private _handleStartDateForSave() {
        this.workflowTriggerSettings.triggerScheduler = this._workflowConfigService.parseSchedulerToParams(this.workflowTriggerSettings.triggerScheduler);
    }

    private _handleTimezoneForSave() {
        const timezone = this.workflowTriggerSettings.triggerScheduler.timezone;
        if (timezone) {
            this.workflowTriggerSettings.triggerScheduler.timezone = timezone.substring(timezone.indexOf(')') + 1);
        }
    }

    private _initData() {
        this.minTime = DateHelperWebService.getDateOnlyOfToday();
        this.maxTime = new Date(this.minTime.getFullYear(), this.minTime.getMonth(), this.minTime.getDate() + 1);
        this._initEntityDropDownData();
        this._initTriggerMethod();
        this._initScheduledJobTrigger();
        this._initKickOffMultipleProjectByEntities();
    }

    private _initEntity() {
        this._destroySubscriptions.push(
            this.entityConfig.onChangeValue$.subscribe(data => {
                if (data) {
                    this.entity = data.shortName;
                    this.workflowTriggerSettings.multipleEntity.relationship.parentEntity = data.id;
                    // need to check relationship error message if parent entity exist
                    this._changeRelationshipErrorMsgStatus();
                }
            }),
        );

        // set relationship
        const entityId = this.workflowTriggerSettings.multipleEntity.relationship.parentEntity;
        this.isRelationshipChecked = this.workflowTriggerSettings.multipleEntity.isRelationshipOptionChecked;
        if (entityId) {
            this.isRelationshipChecked = true;
            this.workflowTriggerSettings.multipleEntity.isRelationshipOptionChecked = true;
            this._entityService.getEntityDetail(entityId).pipe(
                catchError(() => {
                    return of(null);
                }),
                take(1),
            ).subscribe((response) => {
                if (response) {
                    this.entity = response['short-name'];
                }
                this._initFormErrorMsg();
            });
        } else {
            this._initFormErrorMsg();
        }
    }

    private _initEntityDropDownData() {
        this._destroySubscriptions.push(
            this._store.pipe(
                select(currentWorkflowFieldsSelector),
            ).subscribe(fieldBriefs => {
                if (fieldBriefs && fieldBriefs.length) {
                    fieldBriefs.forEach(item => {
                        this.entityItems.push(new PrimaryEntityDrpItem(item.fieldId, item.controlName));
                    });
                    this.entityItemsAll = this.entityItems;
                }
            }),
        );
    }

    private _initEntityType() {
        // entity type
        const selectedEntityTypeId = this.workflowTriggerSettings.multipleEntity.entityType;
        this._store.pipe(select(fullEntityTypeSelector),
            take(1)
        ).subscribe(res => {
            if (res && res.length > 0) {
                res.forEach(item => {
                    this.entityTypeConfig.data.push({
                        id: item.id,
                        name: item.name,
                        selected: selectedEntityTypeId === item.id,
                    });
                });
            }
        });

        this._destroySubscriptions.push(
            this.entityTypeConfig.onChangeValue$.subscribe(data => {
                if (data) {
                    this.entityType = data.name;
                    this.workflowTriggerSettings.multipleEntity.entityType = data.id;
                    this._changeEntityTypeErrorMsgStatus();
                }
            }),
        );

        // set entity type
        const entityTypeId = this.workflowTriggerSettings.multipleEntity.entityType;
        this.isEntityTypeChecked = this.workflowTriggerSettings.multipleEntity.isEntityTypeOptionChecked;
        if (entityTypeId) {
            this.isEntityTypeChecked = true;
            this.workflowTriggerSettings.multipleEntity.isEntityTypeOptionChecked = true;
            this.entityTypeConfig.data.filter(item => {
                if (item.id === entityTypeId) {
                    this.entityType = item.name;
                }
            });
        }
    }

    private _initEvery() {
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            this.everyList = this._monthlyEvery;
            this.selectedEvery = this.everyList.find(item => item.id === this.workflowTriggerSettings.triggerScheduler.every);
            this.onChangeEvery(this.selectedEvery);
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.everyList = this._weeklyEvery;
            this.selectedEvery = this.everyList.find(item => item.id === this.workflowTriggerSettings.triggerScheduler.every);
            this.onChangeEvery(this.selectedEvery);
            if (this.selectedEvery.id > 1) {
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.SINGLE;
            } else {
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.MULTIPLE;
            }
        } else {
            this.everyList = [];
            this.selectedEvery = null;
            this.workflowTriggerSettings.triggerScheduler.every = 1;
        }
    }

    private _initFormErrorMsg() {
        this._changeTriggerMethodErrorMsgStatus();
        this._changeEntityTypeErrorMsgStatus();
        this._changeRelationshipErrorMsgStatus();
        this._changeProjectNameErrorMsgStatus();
    }

    private _initFrequency() {
        this.selectedFrequency = this.frequencyList.find(item => item.id === this.workflowTriggerSettings.triggerScheduler.frequency);
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            this.frequencyUnit = 'month(s)';
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.frequencyUnit = 'week(s)';
        } else {
            this.frequencyUnit = null;
        }
    }

    private _initOn() {
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            let on1Id, on2Id;
            if (this.workflowTriggerSettings.triggerScheduler.on === 'day:L') {
                on1Id = this.workflowTriggerSettings.triggerScheduler.on;
            } else {
                const tempIndex = this.workflowTriggerSettings.triggerScheduler.on.indexOf(':');
                on1Id = this.workflowTriggerSettings.triggerScheduler.on.substring(0, tempIndex);
                on2Id = this.workflowTriggerSettings.triggerScheduler.on.substring(tempIndex + 1);
            }
            this.selectedOnMonthly1 = this.onMonthlyList1.find(item => item.id === on1Id);
            if (this.selectedOnMonthly1.id === 'day') {
                this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyDayList);
                this.onChangeOnMonthly2(this.onMonthlyList2.find(item => item.id === on2Id));
            } else if (this.selectedOnMonthly1.id === 'day:L') {
                this.onMonthlyList2 = [];
                this.selectedOnMonthly2 = null;
            } else {
                this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyXList);
                let tempOnMonthly2 = this.onMonthlyList2.find(item => item.id === on2Id);
                if (!tempOnMonthly2) {
                    tempOnMonthly2 = this.onMonthlyList2[1];
                }
                this.onChangeOnMonthly2(tempOnMonthly2);
            }
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.onWeeklyList.forEach(item => {
                if (this.workflowTriggerSettings.triggerScheduler.on.includes(item.id)) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
            });
        } else {
            this.everyList = [];
            this.selectedEvery = null;
            this.workflowTriggerSettings.triggerScheduler.every = 1;
        }
    }

    private _initRelationshipType() {
        const selectedRelationshipTypeId = this.workflowTriggerSettings.multipleEntity.relationship.type;
        this._store.pipe(select(relationshipTypeSelector
        ),
            take(1)
        ).subscribe(res => {
            if (res && res.length > 0) {
                res.forEach(item => {
                    this.relationshipTypeConfig.data.push({
                        id: item.id,
                        name: item.name,
                        selected: selectedRelationshipTypeId === item.id,
                    });
                });
            }
        });

        this._destroySubscriptions.push(
            this.relationshipTypeConfig.onChangeValue$.subscribe(data => {
                if (data) {
                    this.relationshipType = data.name;
                    this.workflowTriggerSettings.multipleEntity.relationship.type = data.id;
                    this._changeRelationshipErrorMsgStatus();
                }
            }),
        );

        // set relationship
        const relationshipType = this.workflowTriggerSettings.multipleEntity.relationship.type;
        this.isRelationshipChecked = this.workflowTriggerSettings.multipleEntity.isRelationshipOptionChecked;
        if (relationshipType) {
            this.isRelationshipChecked = true;
            this.workflowTriggerSettings.multipleEntity.isRelationshipOptionChecked = true;
            this.relationshipTypeConfig.data.filter(item => {
                if (item.id === relationshipType) {
                    this.relationshipType = item.name;
                }
            });
        }
    }

    private _initStartDate() {
        let _startDate = this.workflowTriggerSettings.triggerScheduler.startDate;
        if (!_startDate) {
            _startDate = DateHelperWebService.getToday();
        } else {
            if (typeof _startDate === 'number') {
                _startDate = new Date(_startDate);
            }
        }
        // do not calculate the start date based on the timezone.
        // this.startDate = this._workflowConfigService.parseStartDateFromServerToUI(_startDate, this.workflowTriggerSettings.minuteOffset);
        this.startDate = _startDate;
        this.onChangeStartDate(this.startDate, false); // Handle 1.0 bug, start date is not converted to time in target time zone. Here will always try to convert start date.
    }

    private _initTime() {
        const timeStr = this.workflowTriggerSettings.triggerScheduler.time;
        const tempIndex = timeStr.indexOf(':');
        const hourStr = timeStr.substring(0, tempIndex);
        const minuteStr = timeStr.substring(tempIndex + 1);
        this.time = new Date(this.minTime.getFullYear(), this.minTime.getMonth(), this.minTime.getDate(), +hourStr, +minuteStr, 0);
    }

    private _initTimezone() {
        this.selectedTimezone = this.timezoneList.find(item => item.id.includes(this.workflowTriggerSettings.triggerScheduler.timezone));
    }

    private _initTimezoneList() {
        this.timezoneList = this._workflowConfigService.timezoneList;
    }

    private _initTriggerMethod() {

    }

    private _initScheduledJobTrigger() {
        this._initFrequency();
        this._initOn();
        this._initEvery();
        this._initTime();
        this._initStartDate();
        this._initTimezone();
    }

    private _initKickOffMultipleProjectByEntities() {
        // init entity type
        this._initEntityType();
        // init relationship type
        this._initRelationshipType();
        // init entity
        this._initEntity();
    }

    private _initWorkflowTriggerSetting() {
        const triggerSetting = this._workflowConfigService.getWorkflowTriggerSettingConfig;
        if (triggerSetting) {
            this.workflowTriggerSettings = triggerSetting;
            if (!this.workflowTriggerSettings.triggerScheduler.timezone) {
                this.workflowTriggerSettings.triggerScheduler.timezone = this._workflowConfigService.getDefaultTimezone();
            }
            if (triggerSetting.triggerSource && triggerSetting.triggerSource.length > 0) {
                this.noteTriggerSource = triggerSetting.triggerSource[0];
            } else {
                const source = new WorkflowTriggerSource();
                source.id = this._workflowService.getIdFromServerInStore(this._store);
                this.noteTriggerSource = source;
            }
        } else {
            this.workflowTriggerSettings = new WorkflowTriggerSettings();
            this.workflowTriggerSettings.triggerScheduler = this._workflowConfigService.getDefaultScheduler();
            this.workflowTriggerSettings.minuteOffset = this.timezoneList.find(item => item.id === this.workflowTriggerSettings.triggerScheduler.timezone).offset;
            this.noteTriggerSource = new WorkflowTriggerSource();
        }
    }

    private _initDefinitionSetting() {
        const definitionSetting = this._workflowConfigService.getDefinitionSettingConfig;
        if (definitionSetting) {
            this.definitionSetting = definitionSetting;
        } else {
            this.definitionSetting = new DefinitionSetting();
        }
    }

    private _saveSetting(invalidSetting = false) {
        // handle special data
        this._handleSpecialData();
        this._handleStartDateForSave();
        this._handleTimezoneForSave();
        const tempWorkflowTriggerSettings = _lodash.cloneDeep(this.workflowTriggerSettings);
        this._workflowConfigService.setWorkflowTriggerSettingConfig = tempWorkflowTriggerSettings;
        this._handleLogicAfterSave('SaveInLocalTemporary');
        this.config.feedbackSubject$.next({
            type: WorkflowTriggerSettingsEventTypes.SAVE,
            payload: {
                triggerSetting: tempWorkflowTriggerSettings,
                definitionSetting: this.definitionSetting,
                invalidSetting: invalidSetting
            }
        });
    }

    private _setDefaultWeeklyOn() {
        this.onWeeklyList.forEach(item => item.selected = false);
        this.onChangeOnWeekly(true, 1);
    }

    private _togglePrimaryEntity(isOn: boolean = true) {
        if (this.primaryEntityEle) {
            this.primaryEntityEle.toggle(isOn);
        }
    }
}
